/** @format */

function MedicareValidation() {
    if ($("#NoMedicare").prop("checked")) {
        $("#Medicare").rules("remove", "required");
        $("#MedicareCardName").rules("remove", "required");

        $("label[for=Medicare]").removeClass("required");
        $("label[for=MedicareCardName]").removeClass("required");
    } else {
        $("#Medicare").rules("add", "required");
        $("#MedicareCardName").rules("add", "required");

        $("label[for=Medicare]").addClass("required");
        $("label[for=MedicareCardName]").addClass("required");
    }
}


$(function () {
    /* query ready function */

    /* /Register/Child */
    if ($("form#childregform").length > 0) {

        $.validator.setDefaults({ ignore: null });
        $(".togglebtn input").on("change", function () {
            $(".toggle").toggle();
        });

        $(".regbutton").on("click", function () {
            $("form").validate();
        });

        $("#Medicare, #NBEN").on('blur', function () {
            $(this).val($(this).val().trim());
        });

        $(".profile-phone-number").change(function () {
            if ($(this).prop('checked')) {
                $(".addChildRow").addClass("d-none");
                $("#AddPhoneButton").attr("disabled", false);
            };
        });

        //Modify the jQuery Validation rules depending on if we have
        //a medicare # provided or not
        $("#NoMedicare").on("change", function () {
            MedicareValidation();
        });
        MedicareValidation();

        $("#AddPhoneButton").click(function () {
            $(".addChildRow").removeClass("d-none");
            $(this).attr("disabled", true);
            $(".profile-phone-number").each(function () {
                $(this).prop("checked", false);
            });
        })

        $("input[type=radio][name=IdType]").change(function() {
            $(".nben-entry, .medicare-entry, .manual-entry").each(function() {
                $(this).addClass("d-none");
            });

            if (this.value == "1") {
                $(".nben-entry").each(function() {
                    $(this).removeClass("d-none");
                });
            }

            if (this.value == "2") {
                $(".medicare-entry").each(function() {
                    $(this).removeClass("d-none");
                });
            }

            if (this.value == "3") {
                $(".manual-entry").each(function () {
                    $(this).removeClass("d-none");
                });
            }
        });

        $("input[type=radio][name=IdType]:checked").change();

        if ($("#DateOfBirth").val() === "0001-01-01") {
            $("#DateOfBirth").val("");
        }
        $(".register-child-page").show();

        function SetTab(index, isLoad) {
            if (index == 0) {
                $("#IdMethodTab").tab("show");

                // Also need to clear the child error and validation errors if user goes back a tab
                if (!isLoad) {
                    $("span.field-validation-error").html("");
                    var errorConfirmSection = $("#ErrorConfirmSection");
                    if (errorConfirmSection) {
                        errorConfirmSection.addClass("d-none");
                        $("#IsErrorConfirmed").prop("checked", false);
                        $("#IsErrorConfirmed").change();
                    }
                }

                $("#ChildDetailsTab").removeClass("complete");
                $("#ChildDetailsTab").addClass("disabled");
                $("#ContactTab").removeClass("complete");
                $("#ContactTab").addClass("disabled");
            } else if (index == 1) {
                $("#ChildDetailsTab").addClass("complete");
                $("#ChildDetailsTab").removeClass("disabled");
                $("#ChildDetailsTab").tab("show");

                $("#ContactTab").removeClass("complete");
                $("#ContactTab").addClass("disabled");

                if (isLoad && !$("#IsNoIdConfirmed").prop("checked")) {
                    $("#ContactTab").removeClass("d-none");
                }
            } else if (index == 2) {
                // need to disble a bunch of stuff here.
                $("#ChildDetailsTab").removeClass("complete");
                $("#ChildDetailsTab").addClass("disabled");
                $("#IdMethodTab").removeClass("complete");
                $("#IdMethodTab").addClass("disabled");
                $("#ContactTab").addClass("complete");
                $("#ContactTab").removeClass("disabled");
                $("#ContactTab").removeClass("d-none");
                $("#ContactBackButton").addClass("d-none");
                $("navbartop a.navbar-brand").on('click', function () { return false; });

                $("#ContactTab").tab("show");
            }

            if (!isLoad) {
                $('.mobiledd div.content').html($(".mdc").html());
                $('.mobiledd span.content').html($('.mobiledd a.active:last').text());
            }
        }

        function OnIdTypeChange(idType, isTrigger) {
            $("#IsNoIdConfirmed").prop("checked", false);
            $(".nben-entry").addClass("d-none");
            $(".medicare-entry").addClass("d-none");
            $("#ChildDetailsTab").addClass("disabled");
            $("#ChildDetailsTab").removeClass("complete");

            var nbenInput = $("#NBEN");
            var medicareCardNameInput = $("#MedicareCardName");
            var medicareInput = $("#Medicare");

            // We don't want to blank these unless the user triggers the event themselves
            if (!isTrigger) {
                nbenInput.val("");
                medicareCardNameInput.val("");
                medicareInput.val("");

                nbenInput.rules("remove", "required");
                medicareCardNameInput.rules("remove", "required");
                medicareInput.rules("remove", "required");
            }

            if (idType == jsIdTypeNben) {
                $(".nben-entry").removeClass("d-none");
                nbenInput.rules("add", "required");

                medicareCardNameInput.rules("remove", "required");
                medicareInput.rules("remove", "required");
            } else if (idType == jsIdTypeMedicare) {
                $(".medicare-entry").removeClass("d-none");
                medicareCardNameInput.rules("add", "required");
                medicareInput.rules("add", "required");
            }
        }



        function SetContactPageEnabled(isEnabled) {
            var contactTab = $("#ContactTab");
            var childDetailsSaveButton = $("#ChildDetailsSaveButton");

            if (isEnabled) {
                contactTab.removeClass("d-none");
                childDetailsSaveButton.val(jsNextLabel);
            } else {
                contactTab.addClass("d-none");
                contactTab.addClass("disabled");
                contactTab.removeClass("complete");
                childDetailsSaveButton.val(jsSaveLabel);
            }
        };

        $("input[type=radio][name=IdType]").change(function (evt) {
            $("#IdMethodButton").prop("disabled", false);
            $("#NoIdConfirmSection").addClass("d-none");
            $("#HelpNeededSection").addClass("d-none");
            SetContactPageEnabled(false);
            OnIdTypeChange($(this).val(), evt.isTrigger);
        });

        $("#NoIdLink").click(function () {
            if (!($("#NoIdConfirmSection").hasClass('d-none'))) return true;
            $("#idMethod_None").prop("checked", true);
            $("#IdMethodButton").prop("disabled", true);
            $("#NoIdConfirmSection").removeClass("d-none");
            SetContactPageEnabled(true);
            OnIdTypeChange(jsIdTypeNone);
            $('#lblMatchedDistrict').html('');

            if ($('#RequestCategoryTypeCd').val() == 6)
            $('.spinner-grow').show();
            var url = window.app.hrefPrefix() + '/' + window.app.currentLanguage() + '/Register/GetAddressDistrict/';
            $.ajax({
                type: "GET",
                url: url,
                dataType: "JSON",
                success: function (data) {
                    if (data.desc) { 
                        $('.spinner-grow').hide();
                        $('#lblMatchedDistrict').html(data.desc);
                    }
                },
                error: function (xhr, strStatus, strError) {
                    console.log(strError);
                    $('.spinner-grow').hide();
                    return true;
                },
                fail: function (err) {
                    window.location.reload();
                }
            });

        });

        $("#IsNoIdConfirmed").change(function () {
            var isConfirmed = $(this).prop("checked");
            $("#IdMethodButton").prop("disabled", !isConfirmed);

            if (!isConfirmed) {
                $("#ChildDetailsTab").addClass("disabled");
                $("#ChildDetailsTab").removeClass("complete");
                $("#ContactTab").addClass("disabled");
                $("#ContactTab").removeClass("complete");
            }
        });

        $("#IdMethodButton").click(function () {
            SetTab(1);
        });

        $("#ChildDetailsBackButton").click(function () {
            SetTab(0);
        });

        $("#IsNoMiddleName").on('change', function () {
            $("#MiddleName-error").addClass("d-none");
            if ($(this).is(":checked")) {
                $("#MiddleName").val("");
                $("#MiddleName").prop("disabled", true);
            } else {
                $("#MiddleName").prop("disabled", false);
            }
        });
        $("#IsNoMiddleName").change();

        $("#ChildDetailsSaveButton.details-save").on('click', function (e) {
            console.log($("#IsErrorConfirmed").prop("checked"));
            if ($("#IsErrorConfirmed").prop("checked")) {
                SetTab(2);
            } else {
                e.preventDefault();
                e.stopPropagation();

                $("#childregform").submit();
            }
        });

        $("#childregform").on('submit', function () {
            if (!$(".medicare-entry").is(":visible")) {
                $("#Medicare").rules("remove", "required");
                $("#Medicare").rules("remove", "validmedicare");
                $("#Medicare").val('');
            }
            if (!$(".nben-entry").is(":visible")) {
                $("#NBEN").rules("remove", "required");
                $("#NBEN").val('');
            }
            if ($("#IsNoMiddleName").is(":checked")) {
                $("#MiddleName").rules("remove", "required");
                $("#MiddleName").val('');
            }
            return $("#childregform").valid();
        });

        $("#ChildDetailsSaveButton.details-next").click(function () {
            SetTab(2);
        });

        $("#IsErrorConfirmed").change(function () {
            SetContactPageEnabled($(this).prop("checked"))
        });

        $("#HelpNeededLink").click(function () {
            $("#HelpNeededSection").removeClass("d-none");
        });

        $("#ContactBackButton").click(function () {
            SetTab(1);
        });

        $(document).on('click', '.nav a', function () {
            SetTab($(this).attr("data-tab"));
        });

        $(document).ready(function () {
            SetTab(jsTabIndex, true);
        });

        $("form").on("submit", function (e) {
            var $this = $(this);
            if ($("form").valid()) {
                $(".regbutton").prop("disabled", true);
                $("#processingModal").modal({ backdrop: "static", keyboard: false });

                $("#modalok").addClass("disabled");

                return true;

                
            } // form.on

            e.preventDefault();
            return false;
        });
    }
});
